import React, { useState, useRef, useEffect } from 'react'
import './UserChatView.css'
import {
  Form,
  InputGroup,
  Button,
  Badge,
  Overlay,
  Tooltip
} from 'react-bootstrap'
import {
  PlusCircle,
  Image,
  Mic,
  Send,
  ChevronUp,
  ChevronDown
} from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import ReactionBar from './ReactionBar '
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { use } from 'react'

// function MessageAction({ setAction }) {
//   return (
//     <div className="messageAction">
//       <button className="btn btn-sm btn-success" title="Move Down">
//         <ion-icon name="arrow-down-outline"></ion-icon>
//       </button>
//     </div>
//   )
// }

function UserChatView({ setAction, handleShow }) {
  const [show, setShow] = useState(false)
  const [target, setTarget] = useState(null)
  const [value, setValue] = useState('')
  const ref = useRef(null)

  const [message, setMessage] = useState('')
  const [showMenu, setShowMenu] = useState(false)
  const [showToolbar, setShowToolbar] = useState(false)

  const handleInputChange = value => {
    setMessage(value)
    console.log(value.trim().length, value)
    setShowToolbar(value.trim().length >= 1 && value !== '<p><br></p>')
  }

  const selectCommand = command => {
    setMessage(prev => `${prev} ${command}`)
    setShowMenu(false) // Close menu after selecting command
  }

  // const handleMouseEnter = event => {
  //   setShow(true)
  //   setTarget(event.target)
  // }

  // const handleMouseLeave = () => {
  //   setShow(false)
  // }

  // // Handle input change
  // const handleInputChange = e => {
  //   const value = e.target.value
  //   setMessage(value)

  //   // Trigger menu when typing '/'
  //   if (value.includes('/')) {
  //     setShowMenu(true)
  //   } else {
  //     setShowMenu(false)
  //   }
  // }

  // // Select command from the menu
  // const selectCommand = command => {
  //   setMessage(command)
  //   setShowMenu(false)
  // }

  return (
    <div className="position-relative UserChatView">
      <div class="chatHeader">
        <Link
          to="/Conversations"
          className="btn btn-outline-primary outline-none border-0 btn-sm px-0 d-flex align-items-center justify-content-center d-sm-none"
        >
          <ion-icon name="chevron-back-outline"></ion-icon>
        </Link>
        <Badge bg="secondary" style={{ width: '4rem' }}>
          #1234
        </Badge>
        <div className="d-md-flex flex-md-wrap w-100 justify-content-between">
          <div className="d-flex flex-column" style={{ lineHeight: '0.5em' }}>
            <h3 className="mb-0">Fleetguard Test</h3>
            <span className="text-muted">
              Fleetguard Filters Private Limited
            </span>
            <span className="timeAgo ms-0" style={{ marginTop: '5px' }}>
              5 min ago
            </span>
          </div>
          {/* <div className="d-flex gap-2 align-items-center mt-1">
            <Badge bg="secondary">#1234</Badge>
            <Badge bg="success">Open</Badge>
          </div> */}
        </div>
        <Badge bg="success" style={{ width: '4rem' }}>
          Open
        </Badge>
        <button
          className="btn btn-outline-primary outline-none border-0 d-block d-lg-none"
          onClick={handleShow}
        >
          <ion-icon
            name="information-circle-outline"
            class="md hydrated m-0"
          ></ion-icon>
        </button>
      </div>
      <div style={{ padding: '10px' }}>
        <div class="message-divider">Friday, Sep 20, 10:40 AM</div>

        <div class="message-item" id="c_1">
          <div class="content">
            <div class="title">Vishal Sahjani</div>
            <div class="bubble">
              <table
                border="0"
                cellpadding="0"
                style={{
                  fontFamily: 'Lato, sans-serif',
                  width: '450px',
                  borderSpacing: '0px'
                }}
              >
                <tbody>
                  <tr>
                    <td style={{ width: '400px' }}>
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <a target="_blank" rel="noopener noreferrer"></a>
                            </td>
                            <td>
                              <table
                                border="0"
                                cellpadding="0"
                                style={{
                                  marginLeft: '15px',
                                  borderSpacing: '0px'
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        lineHeight: '25px',
                                        textTransform: 'uppercase',
                                        color: 'rgb(3, 155, 229)'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Vishal Sahjani
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '300',
                                        color: '#999999',
                                        lineHeight: '25px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Chartered Accountant
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        fontWeight: 300,
                                        color: '#999999',
                                        lineHeight: '25px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        &nbsp;Ahmedabad, Gujarat
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <table style={{ marginLeft: '15px' }}>
                                <tbody>
                                  <tr>
                                    <td style={{ width: '15px' }}>
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      ></a>
                                    </td>
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        color: '#999999',
                                        lineHeight: '15px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        +91-7405123926
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: '15px' }}>
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      ></a>
                                    </td>
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        color: '#999999',
                                        lineHeight: '15px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      ></a>
                                      <a
                                        href="mailto:vishal@sahjani.com"
                                        target="_blank"
                                      >
                                        vishal@sahjani.com
                                      </a>{' '}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: '15px' }}>
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      ></a>
                                    </td>
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        color: '#999999',
                                        lineHeight: '15px',
                                        width: '130px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        vishal.sahjani.com{' '}
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <table>
                        <tbody>
                          <tr>
                            <td valign="bottom" style={{ width: '20px' }}>
                              <span
                                style={{
                                  marginBottom: '5px',
                                  display: 'block',
                                  textDecorationStyle: 'initial',
                                  textDecorationColor: 'initial'
                                }}
                              >
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                ></a>
                              </span>
                              <a
                                href="https://facebook.com"
                                style={{
                                  marginBottom: '5px',
                                  display: 'block',
                                  textDecorationLine: 'none',
                                  textDecorationStyle: 'initial',
                                  textDecorationColor: 'initial'
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                              <a
                                href="https://linkedin.com"
                                style={{
                                  display: 'block',
                                  textDecorationLine: 'none',
                                  textDecorationStyle: 'initial',
                                  textDecorationColor: 'initial'
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="footer d-flex justify-content-between">
              <span className="text-muted">Posted</span> &nbsp; 05/01/2024 5:35
              pm
            </div>
          </div>
        </div>

        <div class="message-item user pe-0" id="c_2">
          <div class="content">
            <div class="title">Anay Jain</div>
            <div class="bubble">
              Please provide screenshots of the issue you're facing while
              accessing the portal.
            </div>
            <div class="footer d-flex justify-content-between">
              <span className="text-muted">Fleetguard Test</span> &nbsp;
              05/01/2024 5:35 pm
            </div>
          </div>
          <ion-icon
            name="person-circle-outline"
            class="mb-2"
            style={{ fontSize: '45px' }}
          ></ion-icon>
        </div>

        <div class="message-item" id="c_3">
          <div class="content">
            <div class="title">Mail Subsystem</div>
            <div class="bubble">
              <table
                border="0"
                cellpadding="0"
                style={{
                  fontFamily: 'Lato, sans-serif',
                  width: '450px',
                  borderSpacing: '0px'
                }}
              >
                <tbody>
                  <tr>
                    <td style={{ width: '400px' }}>
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <a target="_blank" rel="noopener noreferrer"></a>
                            </td>
                            <td>
                              <table
                                border="0"
                                cellpadding="0"
                                style={{
                                  marginLeft: '15px',
                                  borderSpacing: '0px'
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        lineHeight: '25px',
                                        textTransform: 'uppercase',
                                        color: 'rgb(3, 155, 229)'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Vishal Sahjani
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '300',
                                        color: '#999999',
                                        lineHeight: '25px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Chartered Accountant
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        fontWeight: 300,
                                        color: '#999999',
                                        lineHeight: '25px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        &nbsp;Ahmedabad, Gujarat
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <table style={{ marginLeft: '15px' }}>
                                <tbody>
                                  <tr>
                                    <td style={{ width: '15px' }}>
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      ></a>
                                    </td>
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        color: '#999999',
                                        lineHeight: '15px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        +91-7405123926
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: '15px' }}>
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      ></a>
                                    </td>
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        color: '#999999',
                                        lineHeight: '15px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      ></a>
                                      <a
                                        href="mailto:vishal@sahjani.com"
                                        target="_blank"
                                      >
                                        vishal@sahjani.com
                                      </a>{' '}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ width: '15px' }}>
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      ></a>
                                    </td>
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        color: '#999999',
                                        lineHeight: '15px',
                                        width: '130px'
                                      }}
                                    >
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        vishal.sahjani.com{' '}
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <table>
                        <tbody>
                          <tr>
                            <td valign="bottom" style={{ width: '20px' }}>
                              <span
                                style={{
                                  marginBottom: '5px',
                                  display: 'block',
                                  textDecorationStyle: 'initial',
                                  textDecorationColor: 'initial'
                                }}
                              >
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                ></a>
                              </span>
                              <a
                                href="https://facebook.com"
                                style={{
                                  marginBottom: '5px',
                                  display: 'block',
                                  textDecorationLine: 'none',
                                  textDecorationStyle: 'initial',
                                  textDecorationColor: 'initial'
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                              <a
                                href="https://linkedin.com"
                                style={{
                                  display: 'block',
                                  textDecorationLine: 'none',
                                  textDecorationStyle: 'initial',
                                  textDecorationColor: 'initial'
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                              ></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="footer d-flex justify-content-between">
              <span className="text-muted">Posted</span> &nbsp; 05/01/2024 5:35
              pm
            </div>
          </div>
        </div>

        <div class="message-divider">Friday, Sep 20, 10:40 AM</div>

        <div class="message-item " id="c_4">
          <div class="content">
            <div class="title">Mail Subsystem</div>
            <div class="bubble d-flex justify-content-center">
              <table
                cellpadding="0"
                style={{
                  paddingTop: '32px',
                  backgroundColor: '#ffffff',
                  borderSpacing: '0px'
                }}
              >
                <tbody>
                  <tr>
                    <td>
                      <table cellpadding="0" style={{ borderSpacing: '0px' }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                maxWidth: '560px',
                                padding: '24px 24px 32px',
                                backgroundColor: '#fafafa',
                                border: '1px solid #e0e0e0',
                                borderRadius: '2px'
                              }}
                            >
                              <div
                                class="image-hover"
                                style={{
                                  float: 'left;'
                                }}
                              >
                                <img
                                  style={{
                                    padding: '0 24px 16px 0;float:left'
                                  }}
                                  width="72"
                                  height="72"
                                  alt="Error Icon"
                                  src="/file.php?key=ezrw0fgsqgyrj0hsakefnznzjbddrlk0&amp;expires=1734134400&amp;signature=bc20f857a4332015880f79d7510883bec939db82&amp;disposition=inline"
                                  data-cid="ezrW0FgsQGYrj0hsaKEFNZnZJBdDRLK0"
                                />
                                <div class="caption">
                                  <a
                                    href="/file.php?key=ezrw0fgsqgyrj0hsakefnznzjbddrlk0&amp;expires=1734134400&amp;signature=bc20f857a4332015880f79d7510883bec939db82&amp;id=75"
                                    class="dark button pull-right no-pjax"
                                    download="icon.png"
                                    title=""
                                    data-original-title="Download"
                                    target="_blank"
                                  >
                                    <i class="icon-download-alt"></i>
                                  </a>
                                </div>
                              </div>{' '}
                              <table
                                style={{ minWidth: '272px', paddingTop: '8px' }}
                              >
                                <tbody>
                                  <tr>
                                    <td>
                                      <h2
                                        style={{
                                          fontSize: '20px',
                                          color: '#212121',
                                          fontWeight: 'bold'
                                        }}
                                      >
                                        Address not found{' '}
                                      </h2>
                                    </td>
                                  </tr>{' '}
                                  <tr>
                                    <td
                                      style={{
                                        paddingTop: '20px',
                                        color: '#757575',
                                        fontSize: '16px',
                                        fontWeight: 'normal',
                                        textAlign: 'left'
                                      }}
                                    >
                                      Your message wasn't delivered to{' '}
                                      <a
                                        style={{
                                          color: '#212121',
                                          textDecoration: 'none'
                                        }}
                                        target="_blank"
                                      >
                                        <b></b>
                                      </a>
                                      <b>
                                        <a
                                          href="mailto:u_super_01@unacademy.com"
                                          target="_blank"
                                        >
                                          u_super_01@unacademy.com
                                        </a>
                                      </b>{' '}
                                      because the address couldn't be found, or
                                      is unable to receive mail.{' '}
                                    </td>
                                  </tr>{' '}
                                  <tr>
                                    <td
                                      style={{
                                        paddingTop: '24px',
                                        color: '#4285F4',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        textAlign: 'left'
                                      }}
                                    >
                                      <a
                                        style={{ textDecoration: 'none' }}
                                        href="https://support.google.com/mail/?p=NoSuchUser"
                                        target="_blank"
                                      >
                                        LEARN MORE
                                      </a>{' '}
                                    </td>
                                  </tr>{' '}
                                </tbody>
                              </table>{' '}
                            </td>
                          </tr>{' '}
                        </tbody>
                      </table>{' '}
                    </td>
                  </tr>{' '}
                  <tr
                    style={{
                      border: 'none',
                      backgroundColor: '#fff',
                      fontSize: '12.8px',
                      width: '90%'
                    }}
                  >
                    <td align="left" style={{ padding: '48px 10px' }}>
                      The response was:
                      <br />{' '}
                      <p style={{ fontFamily: 'monospace' }}>
                        The email account that you tried to reach does not
                        exist. Please try double-checking the recipient's email
                        address for typos or unnecessary spaces. For more
                        information, go to{' '}
                        <a
                          href="https://support.google.com/mail/?p=NoSuchUser"
                          target="_blank"
                        >
                          https://support.google.com/mail/?p=NoSuchUser
                        </a>{' '}
                      </p>{' '}
                    </td>{' '}
                  </tr>{' '}
                </tbody>
              </table>
            </div>
            {/* <MessageAction setAction={setAction} /> */}
            <div class="footer d-flex justify-content-between">
              <span className="text-muted">Posted</span> &nbsp; 05/01/2024 5:35
              pm
            </div>
          </div>
        </div>

        <div class="message-item user pe-0" id="c_5">
          <div class="content">
            <div class="title">Anay Jain</div>
            <div class="bubble">
              We have raised this issue with Oracle, SR#12345678
            </div>
            <div class="footer d-flex justify-content-between">
              <span className="text-muted">Fleetguard Test</span> &nbsp;
              05/01/2024 5:35 pm
            </div>
          </div>

          <ion-icon
            name="people-circle-outline"
            class=" mb-2"
            style={{ fontSize: '45px' }}
          ></ion-icon>
        </div>
        <div class="message-item user pe-0" id="c_6">
          <div class="content">
            <div class="title">Anay Jain</div>
            <div class="bubble">
              Oracle has suggested to try the solution in DoC ID#123987654,
              please try the same and let us know if it works.
            </div>
            <div class="footer d-flex justify-content-between">
              <span className="text-muted">Fleetguard Test</span> &nbsp;
              05/01/2024 5:35 pm
            </div>
          </div>

          <ion-icon
            name="people-circle-outline"
            class=" mb-2"
            style={{ fontSize: '45px' }}
          ></ion-icon>
        </div>
      </div>

      <div className="border-top bg-white py-3 chatFooter">
        {/* <ReactQuill theme="snow" value={value} onChange={setValue} /> */}
        <Form>
          <InputGroup className="input-with-icon">
            <div className="mobilebadge w-100">
              <ReactQuill
                value={message}
                onChange={handleInputChange}
                placeholder="Message..."
                theme="snow"
                className={`quill-editor ${
                  showToolbar ? 'show-toolbar' : 'hide-toolbar'
                }`}
                modules={{
                  toolbar: true
                }}
              />
            </div>
            <div className="plus-icon-btn d-flex align-items-center">
              <Button
                variant="light"
                className="border-0"
                data-bs-toggle="offcanvas"
                data-bs-target="#actionSheetAdd"
              >
                <PlusCircle size={24} />
              </Button>
              <Button variant="light" className="border-0">
                <Mic size={24} />
              </Button>
              <Button
                type="submit"
                variant="light"
                className="border-0 text-primary"
              >
                <Send size={24} />
              </Button>
            </div>
          </InputGroup>

          {showMenu && (
            <div className="command-menu">
              <ul>
                <li onClick={() => selectCommand('/start')}>
                  <div className="Slidingmenu">
                    <img
                      src="assets/img/sample/avatar/avatar2.jpg"
                      alt="avatar"
                      className="avatar"
                    />
                    /start
                  </div>
                </li>
                <li onClick={() => selectCommand('/off')}>
                  <div className="Slidingmenu">
                    <img
                      src="assets/img/sample/avatar/avatar2.jpg"
                      alt="avatar"
                      className="avatar"
                    />
                    /off
                  </div>
                </li>
                <li onClick={() => selectCommand('/restart')}>
                  <div className="Slidingmenu">
                    <img
                      src="assets/img/sample/avatar/avatar2.jpg"
                      alt="avatar"
                      className="avatar"
                    />
                    /Restart
                  </div>
                </li>
              </ul>
            </div>
          )}
        </Form>
        {/* <Form>
          <InputGroup className="input-with-icon">
            <div className="mobilebadge">
              <Form.Control
                type="text"
                placeholder="Message..."
                value={message}
                onChange={handleInputChange}
                className="rounded-pill bg-light"
              />
            </div>
            <div className="plus-icon-btn">
              <Button
                variant="light"
                className="border-0"
                data-bs-toggle="offcanvas"
                data-bs-target="#actionSheetAdd"
              >
                <PlusCircle size={24} />
              </Button>
              <Button variant="light" className="border-0">
                <Mic size={24} />
              </Button>
              <Button
                type="submit"
                variant="light"
                className="border-0 text-primary"
              >
                <Send size={24} />
              </Button>
            </div>
          </InputGroup>

          {showMenu && (
            <div className="command-menu">
              <ul>
                <li onClick={() => selectCommand('/start')}>
                  <div class="Slidingmenu">
                    <img
                      src="assets/img/sample/avatar/avatar2.jpg"
                      alt="avatar"
                      class="avatar"
                    />
                    /start
                  </div>
                </li>
                <li onClick={() => selectCommand('/off')}>
                  <div class="Slidingmenu">
                    <img
                      src="assets/img/sample/avatar/avatar2.jpg"
                      alt="avatar"
                      class="avatar"
                    />
                    /off
                  </div>
                </li>
                <li onClick={() => selectCommand('/off')}>
                  <div class="Slidingmenu">
                    <img
                      src="assets/img/sample/avatar/avatar2.jpg"
                      alt="avatar"
                      class="avatar"
                    />
                    /Restart
                  </div>
                </li>
              </ul>
            </div>
          )}
        </Form> */}
      </div>
    </div>
  )
}

export default UserChatView
